import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, NavLink, useLocation } from "react-router-dom";
import { Form, Input, Button, Row, Col, Spin, Alert, Select, Tooltip } from "antd";
import logofull from "../assets/logo.png";
import { QuestionCircleOutlined } from '@ant-design/icons';

import { userActions } from "../redux/reducers/user";
import countryList from 'react-select-country-list'

const { Option } = Select;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const Register = () => {
  const location = useLocation()
  const isLoggedIn = useSelector(
    (state) => state.user.isLoggedIn && state.user.jwt !== null
  );
  const signupError = useSelector((state) => state.user.signupError);
  const isFetching = useSelector((state) => state.user.isFetching);
  const isSignupError = signupError ? true : false;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userActions.logOut()); //reset state and clear any errors
  }, [dispatch]);

  const countrySelection = countryList().getData()
  
  
  const onFinish = (values) => {
    const query = new URLSearchParams(location.search);
    const ref = query.get('ref')
    console.log(query)
    console.log(ref)
    values.ref = ref
    console.log(values)
    dispatch(userActions.signUp(values));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const registerForm = (
    <Form
      {...layout}
      name="basic"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="First Name"
        name="firstName"
        rules={[
          {
            required: true,
            message: "Please enter first name!",
            type: "string",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Last Name"
        name="lastName"
        rules={[
          {
            required: true,
            message: "Please enter last name!",
            type: "string",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Country"
        name="country"
      >
      <Select
        showSearch
        placeholder="Select a Country"
        listHeight={100}
        virtual={false}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {
          countrySelection.map(cntry => (
            <Option key={cntry.value} value={cntry.label}>{cntry.label}</Option>
          ))
        }
      </Select>
      </Form.Item>

      <Form.Item
        label="Phone Num."
        name="phone"
        rules={[
          {
            type: "string",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={
          <span>
            Nickname&nbsp;
            <Tooltip title="What do you want others to call you?">
              <QuestionCircleOutlined />
            </Tooltip>
          </span>
        }
        name="username"
        rules={[
          {
            required: true,
            message: "Please enter your Nickname!",
            type: "string",
            whitespace: true,
          },
        ]}
      >
        <Input autoComplete="off"/>
      </Form.Item>

      <Form.Item
        label="E-mail"
        name="email"
        rules={[
          {
            required: true,
            message: "Please enter your email!",
            type: "email",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: "Please enter your password!" }]}
      >
        <Input.Password />
      </Form.Item>
      <Row>
        <Button type="primary" htmlType="submit" block>
          Submit
        </Button>
      </Row>
      <Row type="flex" justify="center" align="middle">
        Already have an account?<NavLink to="/signin"> Log In!</NavLink>
      </Row>
    </Form>
  );

  if (isLoggedIn) return <Redirect to="/" />

  return (
    <div className="signin-form">
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
      >
        {isSignupError && (
          <Alert
            message={signupError}
            type="error"
            closable
            showIcon
            banner
            style={{ position: "absolute", top: "50px" }}
          />
        )}
        <Col>
          <Spin spinning={isFetching} delay={200}>
            <img
              src={logofull}
              alt="Logo"
              className="logo-full"
              style={{ marginBottom: 15 }}
            />
            {registerForm}
          </Spin>
        </Col>
      </Row>
    </div>
  );
};

export default Register;
